<template>
  <div
    class="ms-grid-viewer flex"
    :class="{
      selectedTextMode: selectedTextMode,
      'flex-column': flex,
      'has-scroll-x': hasScrollX,
      'has-scroll-y': hasScrollY,
      'has-paging': pagination,
      'has-footer': footer,
      'has-border-around': hasBorderAround,
      'ms-grid-viewer-no-data': dataEmpty,
    }"
  >
    <transition>
      <request-loading-indicator
        v-if="loading && isLoadOnScroll"
        :show-overlay="true"
        :width="24"
        :height="24"
      />
    </transition>
    <div
      ref="content"
      :class="[
        'ms-content--table',
        { 'no-data': dataEmpty },
        stickeyCountClass,
        { scroller: flex && !dataEmpty },
      ]"
      :style="[gridViewStyle]"
      @scroll="tableScroll"
    >
      <div class="grid-scroll">
        <table class="ms-table" cellpadding="0" cellspacing="0">
          <thead
            v-show="isShowHeader"
            ref="thead"
            class="ms-thead"
            :class="{ multi: headers.length > 1 }"
          >
            <template v-for="(headerItem, i1) in headers" :key="i1">
              <draggable
                v-if="dataDragable"
                v-model="headers[0]"
                tag="tr"
                class="ms-tr"
              >
                <th
                  v-if="multiple && i1 === 0"
                  :key="0"
                  class="ms-th multiple-cell sticky ms-th-col"
                  :rowspan="0"
                  scope="col"
                >
                  <ms-checkbox
                    v-model="checkedAll"
                    class="justify-center"
                    :class="{
                      'checkmark-temp': !checkedAll && isTempState,
                    }"
                    check-only
                    @click="changeCheckedMultiple"
                  />
                </th>

                <th
                  v-if="serial && i1 === 0"
                  class="ms-th serial text-center ms-th-col"
                  :style="{ left: serialOffsetLeft }"
                  :class="{ sticky: hasLockColumn }"
                  :rowspan="0"
                >
                  {{ $t('i18nComponent.HeaderOption.SortOrderColumn') }}
                </th>

                <template v-for="(col, i2) in headers[0]" :key="i2">
                  <th
                    v-if="col.isGroup"
                    :class="[
                      'ms-th ms-col-th ms-col-th-span',
                      i2 === headerItem.length - 1 ? 'ms-col-th-last' : '',
                    ]"
                    :colspan="col.colspan"
                  >
                    <div class="ms-th-content flex-row">
                      <div class="flex flex-row">
                        <div
                          v-if="col.lockable !== false && !col.group"
                          class="icon24 lock"
                          :class="{ locked: col.lock }"
                          @click="columnChangeLock(col)"
                        />
                        <span class="flex">{{ col.caption }}</span>
                      </div>
                    </div>
                  </th>
                  <ms-th
                    v-else
                    ref="th"
                    :key="col.dataField"
                    :class="[
                      'ms-th',
                      '' + col.dataField,
                      i2 === headerItem.length - 1 ? 'ms-col-th-last' : '',
                    ]"
                    :rowspan="i1"
                    :col="col"
                    :resize-col="resizeCol"
                    :filterable="filterable"
                    :module-autocomplete="moduleAutocomplete"
                    :has-border-around="hasBorderAround"
                    scope="col"
                    @filter="columnFilter"
                    @resizeOff="resizeClose"
                    @sort="sort"
                    @changeColumnResize="changeColumnResize"
                    @changeLock="columnChangeLock"
                    @resizeOn="handlerResizeOn"
                  />
                </template>

                <th
                  v-if="$slots['widget-title'] && i1 === 0"
                  :key="100"
                  class="ms-th widget-title ms-th-col"
                  :rowspan="0"
                  scope="col"
                >
                  <slot name="widget-title" />
                </th>
              </draggable>
              <tr v-else class="ms-tr" :class="[{'not-has-border-around' : !hasBorderAround}, `tr-${i1 + 1}`]">
                <th
                  v-if="multiple && i1 === 0"
                  class="ms-th multiple-cell sticky ms-th-col"
                  :rowspan="0"
                >
                  <ms-checkbox
                    v-model="checkedAll"
                    :class="{
                      'checkmark-temp': !checkedAll && isTempState,
                    }"
                    class="justify-center"
                    check-only
                    @click="changeCheckedMultiple"
                  />
                </th>

                <th
                  v-if="serial && i1 === 0"
                  :style="{ left: serialOffsetLeft }"
                  class="ms-th serial text-center ms-th-col"
                  :class="{ sticky: hasLockColumn }"
                  :rowspan="headers.length"
                >
                  {{ $t('i18nComponent.HeaderOption.SortOrderColumn') }}
                </th>

                <template v-for="(col, i2) in headerItem" :key="i2">
                  <th
                    v-if="col.isGroup"
                    :class="[
                      'ms-th ms-col-th ms-col-th-span',
                      i2 === headerItem.length - 1 ? 'ms-col-th-last' : '',
                    ]"
                    :colspan="col.colspan"
                  >
                    <div class="ms-th-content flex-row">
                      <div class="flex flex-row w-100">
                        <!-- <div
                          v-if="col.lockable !== false && !col.group"
                          class="icon24 lock"
                          :class="{ locked: col.lock }"
                          @click="columnChangeLock(col)"
                        ></div> -->
                        <span class="flex-center w-100">{{ col.caption }}</span>
                      </div>
                    </div>
                  </th>
                  <ms-th
                    v-else
                    ref="th"
                    :key="col.dataField"
                    :class="[
                      'ms-th',
                      i2 === headerItem.length - 1 ? 'ms-col-th-last' : '',
                    ]"
                    :rowspan="0"
                    :col="col"
                    :resize-col="resizeCol"
                    :filterable="filterable"
                    :module-autocomplete="moduleAutocomplete"
                    :has-border-around="hasBorderAround"
                    @filter="columnFilter"
                    @resizeOff="resizeClose"
                    @sort="sort"
                    @changeColumnResize="changeColumnResize"
                    @changeLock="columnChangeLock"
                    @resizeOn="handlerResizeOn"
                  />
                </template>

                <slot
                  v-if="$slots['widget-title-th'] && i1 === 0"
                  name="widget-title-th"
                  :rowspan="0"
                />
                <th
                  v-else-if="$slots['widget-title'] && i1 === 0"
                  class="ms-th widget-title ms-th-col"
                  :rowspan="0"
                >
                  <slot name="widget-title" />
                </th>
              </tr>
            </template>
          </thead>
          <transition mode="out-in">
            <tbody v-if="loading && !isLoadOnScroll">
              <tr v-for="n in shimmerRow" :key="n" :index="n">
                <td
                  v-for="(sc, i) in shimmerColumn"
                  :key="i"
                  :class="{ sticky: sc.lock }"
                  :style="{
                    left:
                      typeof sc.offset == 'number' ? sc.offset + 'px' : 'unset',
                    borderRight: '1px dotted #c1c4cc',
                  }"
                >
                  <div class="shimmer" />
                </td>
              </tr>
            </tbody>
          </transition>
          <transition name="trans-content-table" mode="out-in">
            <!-- v-on:before-enter="beforeRenderContent" -->
            <!-- <template v-if="loading">
              <tbody class="ms-tbody grid-loading" :key="loading"></tbody>
            </template> -->
            <tbody
              v-if="!dataEmpty && (!loading || isLoadOnScroll) && !rowDraggable"
              :key="loading"
              class="ms-tbody data"
              @click="quickSelected"
              @keyup="destroyQuickSelected"
            >
              <tr v-if="summaryData" class="ms-tr" :class="[{'not-has-border-around' : !hasBorderAround}]">
                <td class="ms-td ms-col-td text-center summary summary-title" :class="[{'not-has-border-around' : !hasBorderAround}]">
                  Tất cả
                </td>
                <template v-for="(footerItem, i1) in footers" :key="i1">
                  <td
                    v-for="(col, i2) in footerItem"
                    :key="i2"
                    class="ms-td ms-col-td summary cursor-pointer"
                    :class="[`text-${col.align || 'left'}`]"
                    @click="
                      $emit('onClickSummary', {
                        col,
                        data: summaryData[col.dataField],
                        index: i2,
                      })
                    "
                  >
                    <span>{{ summaryData[col.dataField] }}</span>
                  </td>
                </template>
              </tr>
              <template v-if="groupField && rowSpanGroup">
                <template
                  v-for="(group, indexRow) in groupDataRowSpan"
                  :key="[indexRow].join('-')"
                >
                  <ms-tr-row-span
                    ref="tr"
                    :is-selected="isSelected(group)"
                    :is-checked-all="checkedAll"
                    :columns="columnx"
                    :index="indexRow"
                    :data-row="group"
                    :serial="serial"
                    :serial-offset-left="serialOffsetLeft"
                    :page-size="pageSize"
                    :current-page="currentPage"
                    :multiple="multiple"
                    :row-selected="rowSelected.data"
                    :row-actions="rowActions"
                    :isShowRowAction="isShowRowAction"
                    :action-inline-count="actionInlineCount"
                    :disabled-checked-multiple-tbody="
                      funDisabledCheckedMultipleTbody(group)
                    "
                    :class="[
                      {
                        'multi-row-selected': shortkeyQuickSelectedData.includes(
                          group
                        ),
                      },
                      { 'action-pointer': checkListenerDbClick },
                      typeof customClassRow == 'function'
                        ? customClassRow(group)
                        : customClassRow,
                    ]"
                    :has-lock-column="hasLockColumn"
                    :group-field="groupField"
                    v-on="listeners"
                    @dblclick="$emit('rowDbClick', group, $event)"
                    @focus="onFocusRow(group, $event)"
                    @click="onClickRow(group, $event)"
                    @styleColumn="styleColumn"
                  >
                    <template v-if="$slots['widget-body']" #widget>
                      <slot name="widget-body" :record="group" />
                    </template>
                  </ms-tr-row-span>
                </template>
              </template>

              <template v-else-if="groupField">
                <template
                  v-for="(group, indexRow) in groupData"
                  :key="[indexRow, group.value].join('-')"
                >
                  <!-- key để phức tạp như vậy để tránh trùng với các đối tượng khác -->
                  <ms-tr-group
                    v-if="group.isGroup"
                    class="ms-tr"
                    :column-sumary="columnSumary"
                    :data-row="group"
                    @toogleTree="toggleTree"
                  >
                    <template v-if="$slots['widget-body']" #widget>
                      <slot name="widget-body" :record="group" />
                    </template>
                  </ms-tr-group>
                  <ms-tr
                    v-else
                    ref="tr"
                    :key="group[idField]"
                    :is-selected="isSelected(group)"
                    :is-checked-all="checkedAll"
                    :columns="columnx"
                    :index="indexRow"
                    :data-row="group"
                    :serial="serial"
                    :serial-offset-left="serialOffsetLeft"
                    :page-size="pageSizeInternal"
                    :current-page="currentPage"
                    :multiple="multiple"
                    :row-selected="rowSelected.data"
                    :row-actions="rowActions"
                    :isShowRowAction="isShowRowAction"
                    :has-border-around="hasBorderAround"
                    :action-inline-count="actionInlineCount"
                    :disabled-checked-multiple-tbody="
                      funDisabledCheckedMultipleTbody(group)
                    "
                    :class="[
                      {
                        'multi-row-selected': shortkeyQuickSelectedData.includes(
                          group
                        ),
                      },
                      { 'action-pointer': checkListenerDbClick },
                      typeof customClassRow == 'function'
                        ? customClassRow(group)
                        : customClassRow,
                    ]"
                    :has-lock-column="hasLockColumn"
                    v-on="listeners"
                    @dblclick="$emit('rowDbClick', group, $event)"
                    @focus="onFocusRow(group, $event)"
                    @click="onClickRow(group, $event)"
                    @styleColumn="styleColumn"
                  >
                    <template v-if="$slots['widget-body']" #widget>
                      <slot name="widget-body" :record="group" />
                    </template>
                  </ms-tr>
                </template>
              </template>
              <template v-else>
                <!-- <draggable
                  :list="datax"
                  class="ms-tbody"
                  tag="tbody"
                  @change="onDraggableChanged"
                > -->
                <ms-tr
                  v-for="(dataRow, indexRow) in datax"
                  ref="tr"
                  :key="dataRow[idField]"
                  :is-selected="isSelected(dataRow)"
                  :is-custom-check-box="isCustomCheckBox"
                  :is-checked-all="checkedAll"
                  :columns="columnx"
                  :index="indexRow"
                  :data-row="dataRow"
                  :serial="serial"
                  :serial-offset-left="serialOffsetLeft"
                  :page-size="pageSizeInternal"
                  :current-page="currentPage"
                  :multiple="multiple"
                  :row-selected="rowSelected.data"
                  :has-border-around="hasBorderAround"
                  :row-actions="rowActions"
                  :isShowRowAction="isShowRowAction"
                  :is-select-when-click-row="isSelectWhenClickRow"
                  :action-inline-count="actionInlineCount"
                  :disabled-checked-multiple-tbody="
                    funDisabledCheckedMultipleTbody(dataRow)
                  "
                  :class="[
                    {
                      'multi-row-selected': shortkeyQuickSelectedData.includes(
                        dataRow
                      ),
                    },
                    { 'action-pointer': checkListenerDbClick },
                    typeof customClassRow == 'function'
                      ? customClassRow(dataRow)
                      : customClassRow,
                  ]"
                  :has-lock-column="hasLockColumn"
                  v-on="listeners"
                  @dblclick="$emit('rowDbClick', dataRow, $event)"
                  @focus="onFocusRow(dataRow, $event)"
                  @click="onClickRow(dataRow, $event)"
                  @styleColumn="styleColumn"
                >
                  <!-- Nếu type của cột là custom thì sẽ truyền template slot vào -->
                  <!-- Nếu type của cột là default thì sẽ hiển thị giá trị như bình thường -->
                  <template #grid-cell="{ col }">
                    <slot :name="col.dataField" :record="dataRow" />
                  </template>
                  <!-- <template #ID>
                      <slot :name="'ID'" :record="dataRow" />
                  </template> -->
                  <!-- <template v-if="$slots['widget-body']" v-slot:widget>
                    <slot name="widget-body" :record="dataRow" />
                  </template> -->
                </ms-tr>
                <!-- </draggable> -->
              </template>
            </tbody>
            <draggable
              v-else-if="
                !dataEmpty && rowDraggable && (!loading || isLoadOnScroll)
              "
              :list="datax"
              class="ms-tbody"
              tag="tbody"
              @change="onDraggableChanged"
            >
              <ms-tr
                v-for="(dataRow, indexRow) in datax"
                ref="tr"
                :key="dataRow[idField]"
                :is-selected="isSelected(dataRow)"
                :is-checked-all="checkedAll"
                :is-custom-check-box="isCustomCheckBox"
                :columns="columnx"
                :index="indexRow"
                :data-row="dataRow"
                :serial="serial"
                :page-size="pageSizeInternal"
                :serial-offset-left="serialOffsetLeft"
                :current-page="currentPage"
                :multiple="multiple"
                :row-selected="rowSelected.data"
                :row-actions="rowActions"
                :isShowRowAction="isShowRowAction"
                :action-inline-count="actionInlineCount"
                :disabled-checked-multiple-tbody="
                  funDisabledCheckedMultipleTbody(dataRow)
                "
                :class="[
                  {
                    'multi-row-selected': shortkeyQuickSelectedData.includes(
                      dataRow
                    ),
                  },
                  { 'action-pointer': checkListenerDbClick },
                  typeof customClassRow == 'function'
                    ? customClassRow(dataRow)
                    : customClassRow,
                ]"
                :has-lock-column="hasLockColumn"
                v-on="listeners"
                @dblclick="$emit('rowDbClick', dataRow, $event)"
                @focus="onFocusRow(dataRow, $event)"
                @click="onClickRow(dataRow, $event)"
                @styleColumn="styleColumn"
              >
                <!-- Nếu type của cột là custom thì sẽ truyền template slot vào -->
                <!-- Nếu type của cột là default thì sẽ hiển thị giá trị như bình thường -->
                <template #grid-cell="{ col }">
                  <slot :name="col.dataField" :record="dataRow" />
                </template>
                <!-- <template #ID>
                      <slot :name="'ID'" :record="dataRow" />
                  </template> -->
                <!-- <template v-if="$slots['widget-body']" v-slot:widget>
                    <slot name="widget-body" :record="dataRow" />
                  </template> -->
              </ms-tr>
            </draggable>
            <div
              v-else-if="isShowImageGridEmpty && !loading && dataEmpty"
              class="grid-no-data"
            >
              <img
                src="@/assets/images/empty/bg_report_nodata.svg"
                class="img-bg"
              >
              <div class="empty-des">
                {{ $t('i18nCommon.noData') }}
              </div>
            </div>
          </transition>
        </table>

        <div
          v-if="footer && !loading"
          ref="tableFooter"
          class="table-footer"
          :class="[stickeyCountClass, { visibility: dataEmpty }]"
        >
          <table cellspacing="0">
            <tfoot :key="loading" class="ms-footer data">
              <tr v-for="(footerItem, i1) in footers" :key="i1" class="ms-tr">
                <!-- <th
              class="ms-th multiple-cell sticky"
              v-if="multiple && i1 === 0"
              :rowspan="footers.length"
              style="left: 0"
            >
              <ms-checkbox
                :value="checkedAll"
                @click="changeCheckedMultiple"
                class="justify-center"
                checkOnly
                style="display: none"
              />
            </th> -->
                <template v-for="(col, i2) in footerItem" :key="i2">
                  <th
                    v-if="col.isGroup"
                    :colspan="col.colspan"
                    :class="[
                      'ms-th ms-col-th ms-col-th-span',
                      i2 === headerItem.length - 1 ? 'ms-col-th-last' : '',
                      { sticky: typeof col.stickyOffset === 'number' },
                    ]"
                    style="left: 0"
                  >
                    <span>{{ col.caption }}</span>
                  </th>
                  <!-- <th
                    v-else-if="col.stickyRight"
                    class="sticky"
                    style="right: 0"
                    :style="getFooterStyle(col)"
                  ></th> -->
                  <th
                    v-else
                    :colspan="col.colspan"
                    :class="[
                      { sticky: typeof col.stickyOffset === 'number' },
                      col.dataField,
                    ]"
                    class="ms-th-viewer static-col"
                    :style="getFooterStyle(col)"
                  >
                    <div
                      class="flex"
                      :class="[`text-${col.align || 'left'}`, col.classes]"
                    >
                      <span v-if="typeof col.footerText == 'string'">
                        {{ col.footerText }}
                      </span>
                      <span
                        v-else-if="summaryData"
                        :class="[`text-${col.align || 'left'}`]"
                      >{{ getSummaryDisplay(col, i1, i2) }}</span>
                      <span
                        v-else
                        :class="[
                          `text-${col.align || 'left'}`,
                          {
                            'footer-total-count':
                              col.summaryType ===
                              $ms.constant.SummaryType.RowCount,
                          },
                        ]"
                        v-html="getSummaryDisplay(col, i1, i2)"
                      />
                    </div>
                  </th>
                  <!-- <th
                    v-else
                    class="sticky"
                    style="right: 0"
                    :style="getFooterStyle(col)"
                  ></th> -->
                </template>

                <th
                  v-if="widgetOptions && i1 === 0"
                  class="ms-th widget-title"
                  :rowspan="footers.length"
                  :class="[
                    `text-${
                      widgetOptions.align ? widgetOptions.align : 'right'
                    }`,
                  ]"
                  :style="[
                    { 'min-width': `${widgetOptions.width}px` },
                    columnx.length > 0
                      ? { width: `${widgetOptions.width}px` }
                      : null,
                  ]"
                />

                <!-- <th
                  class="ms-th widget-title"
                  v-if="col.stickyRight"
                  :style="getFooterStyle(col)"
                ></th> -->

                <!-- <slot
              name="widget-summary-th"
              v-if="$slots['widget-summary-th'] && i1 === 0"
            />
            <th
              v-else-if="$slots['widget-summary'] && i1 === 0"
              class="ms-th widget-title"
              :rowspan="0"
            >
              <slot name="widget-summary" />
            </th> -->
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
    <ms-pagination
      v-if="pagination"
      class="table-paging"
      :page-size="pageSizeInternal"
      :data-render="datax.length"
      :page-index="currentPage"
      :summary="summary"
      :page-total="totalCount"
      :is-show-right-footer="isShowRightFooter"
      @loadData="listenersLoadData"
      @changePageSize="changePageSize"
    />

    <div v-if="disabled" class="disabled" />

    <!-- <div class="loading grid-loading" v-if="loading"> -->
    <!-- <div class="loadingio-spinner-dual-ball-p4fazz803e">
        <div class="ldio-z76ep1av69">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div> -->
    <!-- <div class="loading-cover"></div>
      <div class="loading-svg">
        <div class="effect-1 effects"></div>
      </div>
    </div> -->
  </div>
</template>
<script>
import msTr from './MsTr';
import msTrGroup from './MsTrGroup';
import msTrRowSpan from './MsTrRowSpan';
import msTh from './MsTh';
import msPagination from './MsPagination';
import RequestLoadingIndicator from '@/components/loading/RequestLoadingIndicator.vue';
import { gridGroupData } from '@/mixins/component/gridGroupData';
import { VueDraggableNext } from 'vue-draggable-next';

import summaryUtil from '@/commons/summaryUtil';
import { filter } from '@/mixins/common/filter.js';
import { useColumnResize } from '@/setup/grid/resizeColumn.js';
import { getCurrentInstance, nextTick, onMounted } from 'vue';
import commonFn from '@/commons/commonFunction.js';

export default {
  name: 'MsGridViewer',
  components: {
    RequestLoadingIndicator,
    msTr,
    msTh,
    msPagination,
    draggable: VueDraggableNext,
    msTrGroup,
    msTrRowSpan,
  },
  mixins: [gridGroupData, filter],
  props: {
    // Có phải cột động ko
    isDynamicColumns: {
      type: Boolean,
      default: false,
    },
    // Có chọn khi click vào dòng ko
    isSelectWhenClickRow: {
      type: Boolean,
      default: false,
    },
    // Có cho phép kéo thả cột ko
    rowDraggable: {
      type: Boolean,
      default: false,
    },
    // Có border xung quanh ko
    hasBorderAround: {
      type: Boolean,
      default: false,
    },
    /**
     * Mặc định lựa chọn dòng đầu tiên
     */
    isCheckFirstRow: {
      type: Boolean,
      default: false,
    },

    // Có highlight dòng đc chọn ko
    isHighlightRowSelected: {
      type: Boolean,
      default: true,
    },
    // Có phải là mode load dữ liệu khi scroll ko
    isLoadOnScroll: {
      type: Boolean,
      default: false,
    },
    widgetOptions: {},
    flex: {
      default: true,
      type: Boolean,
    },
    rowSpanGroup: {
      default: false,
      type: Boolean,
    },
    /**
     * có show text filter khi lọc ra không
     */
    hasBindingFilterHeader: {
      default: false,
      type: Boolean,
    },
    /**
     * Value thực hiện lưu giá trị các cột được chọn
     */
    selected: {
      type: Array,
      default: () => [],
    },
    //Data dữ liệu grid từ ngoài truyền vào
    data: {
      type: Array,
      default: () => [],
    },
    /**
     * Tên trường khóa chính
     */
    idField: {
      type: String,
      default: '',
    },
    /**
     * nnlam 13/03/2021
     * cấu hình các trường cần sort mặc định khi load trang
     * Kiểu dữ liệu Array chứa danh sách các object, cấu trúc object có ít nhất 2 trường là sortField(tên property cần sort) và sortType (là desc hay asc)
     * ví dụ : [{sortField: 'AssetCode', sortType : this.$ms.constant.SortStatus.asc}]
     */
    defaultSort: {
      type: Array,
      default: () => [],
    },
    //Cấu hình các cột truyền vào
    /**
     * Các thuộc tính trong columns
     * @params dataField Field dữ liệu dùng để nhận giá trị thay đổi và hiện thị.
     * @params title:Tiêu đề của cột
     * @params width:độ rộng của cột
     * @params autoResize:Cột tự động to ra khi màn hình lớn
     * @params formatType:Dữ liệu dùng để format lấy từ trong file enumeration.js FormatType
     * @params template:Sử dụng 1 file khác ở ngoài truyền vào để render
     */
    columns: {
      type: Array,
      default: () => [],
    },
    //Set độ rộng cho grid
    maxHeight: {
      default: null,
      type: [Number, String],
    },
    //Cấu hình có phân trang hay không
    pagination: {
      default: false,
      type: Boolean,
    },
    /*
    Cho phép hiển thị header của lưới hay không? mặc định có
    Create: 14/01/2020
    Author: ĐVThi
    */
    isShowHeader: {
      default: true,
      type: Boolean,
    },
    //Nhận 2 giá trị remote/local để lấy giá trị ở server hoặc local
    queryMode: {
      default: 'remote',
      type: String,
    },
    //Số bản ghi trên mới trang trường hợp phân trang local
    pageSize: {
      default: 20,
      type: Number,
    },
    //Cột cho phép tích chọn nhiều dòng
    multiple: {
      default: false,
      type: Boolean,
    },
    // Cho phép hiển thị số dòng
    showTotalRecord: {
      default: false,
      type: Boolean,
    },
    indexFlexRight: {
      default: 1,
      type: Number,
    },
    //Tổng số bản ghi
    pageTotal: {
      default: 0,
      type: Number,
    },
    /**
     * thông tin summary
     * trong này sẽ có total luôn
     */
    summary: {
      type: [Object, String, Number],
      default: null,
    },
    //Hiện thị cột số thứ tự
    serial: {
      default: false,
      type: Boolean,
    },
    //Cho phép di chuyển độ rộng của cột hay không
    resizeCol: {
      default: true,
      type: Boolean,
    },
    //Trường để kiểm tra sort dưới client hay trên sever
    //Local/Serve
    sortMode: {
      default: 'remote',
      type: String,
    },
    hasFilterEmpty: {
      default: false,
      type: Boolean,
    },
    loading: {
      type: Boolean,
      default: true,
    },
    loadingSummary: {
      type: Boolean,
      default: true,
    },
    customClassRow: {
      type: [String, Object, Array],
      default: null,
    },
    loadChildrenData: {
      type: [String, Object, Array, Number],
      default: null,
    },
    /**
     * Action của row
     */
    rowActions: {
      default: null,
      type: [Object, Array],
    },
    /**
     * Số lượng item hiển thị inline khi hover vào dòng
     * nếu vượt quá số lượng này thì sẽ đặt trong more ...
     */
    actionInlineCount: {
      default: 5,
      type: Number,
    },
    /**
     * Disable control
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * Số dòng shimmer loading
     */
    shimmerRow: {
      type: Number,
      default: 6,
    },
    /*
     * thêm cấu hình những cột luôn lấy khi load grid
     * pvduy 19/01/2021
     */
    alwayTakeColumns: {
      default: null,
      type: Array,
    },
    /**
     * có filter cột không
     */
    filterable: {
      type: Boolean,
      default: true,
    },
    /**
     * Cho phép sắp xếp lại dữ liệu
     */
    dataDragable: {
      default: false,
      type: Boolean,
    },
    /*
     * pvduy 19/03/2021
     * cờ xác nhận xem có cho hiện ảnh trống khi grid ko có dữ liệu hay không? ==> sử dụng trong grid detail dù trống vẫn ẩn ảnh đi.
     */
    isShowImageGridEmpty: {
      default: true,
      type: Boolean,
    },

    //Có footer hay không ?
    footer: {
      default: false,
      type: Boolean,
    },
    /*
     * nnlam 14/04/2021
     * có cache cấu hình cột không, hiện tại nếu lưu cache sẽ lưu khi resize cột
     */
    hasCacheCol: {
      default: false,
      type: Boolean,
    },
    /*
     * nnlam 14/04/2021
     * khi queryMode = 'local' thì dùng cái này để filter
     */
    filterFn: {
      default: false,
      type: [Boolean, Function],
    },
    /*
     * nnlam 14/04/2021
     * cho phép check disable ô checkbox ở row
     */
    disabledCheckedMultipleTbody: {
      default: false,
      type: [Boolean, Function],
    },

    //module để thực hiện autocomplete khi lọc trên th
    moduleAutocomplete: {
      type: String,
      default: null,
    },
    /**
     * Dữ liệu tổng
     * Dùng cho sum lấy từ server truyền vào (không phụ thuộc vào trang đang hiển thị)
     */
    summaryData: {
      type: Object,
      default: null,
    },
    /**
     * Dữ liệu tổng
     * Dùng cho sum lấy từ server truyền vào (không phụ thuộc vào trang đang hiển thị)
     */
    isAutoFocusFirstRow: {
      type: Boolean,
      default: false,
    },

    /**
     * Thuộc tính dùng nhưng chưa được định nghĩa => thêm vào tuy nhiên chưa rõ cụ thể làm gì
     * HTHIEP 21.03.2022
     */
    _events: {
      type: Object,
      default: null,
    },

    /**
    Text tìm kiếm
     */
    searchText: {
      type: String,
      default: () => '',
    },

    /**
     * Danh sách bộ lọc khác, cần theo đúng tên properties như vd thì mới lọc được
     * vd : lọc thêm theo trạng thái theo dõi/ ngừng theo dõi:
     *    {"inactive": 1}
     *
     */
    filterObject: {
      type: Object,
      default: () => {},
    },

    /**
     * Custom thêm lọc grid
     **/
    customFilter: {
      default: null,
      type: [Function, Array],
    },
    isShowRightFooter: {
      default: true,
      type: Boolean,
    },
    isCustomCheckBox: {
      default: false,
      type: Boolean,
    },
    /**
     * Có hiển thị row action không
     * Mặc định là false vì hiện tài nhiều nơi đang không dùng base
     */
    isShowRowAction: {
      type: Boolean,
      default: false,
    },
    /**
     * Tên cột action
     */
    headerActionText: {
      type: String,
      default: 'Chức năng',
    }
  },
  emits: [
    'onScrollBottom',
    'rowmouseover',
    'grid_styleColumn',
    'update:selected',
    'firstLoad',
    'onCheckedAll',
    'resizeCol',
    'onClickRowCustom',
    'rowDbClick',
    'drilldownClick',
    'viewMoreDetails',
    'viewLinkedForm',
    'rowactionclick',
    'keydown',
    'loadData',
    'onDraggableChanged',
    'changePageSize',
    'onClickSummary',
  ],
  /**
   * Setup hook
   */
  setup(props, { emit }) {
    const { changeColumnResize, handlerResizeOn } = useColumnResize({
      props,
      emit,
    });
    onMounted(() => {
      nextTick(() => {
        setTimeout(() => {
          proxy.updateFooterContainer();
        }, 300);
      });
    });
    const { proxy } = getCurrentInstance();

    /**
     * Xử lý ẩn hiện dạng cây group
     * NCPHUOC 27/05/2022
     */
    const toggleTree = (dataRow) => {
      const data = proxy.groupData.find((x) => x === dataRow);
      if (data) {
        data.expanded = !data.expanded;
        changeVisibleTr(data, data.expanded);
      }
    };

    /**
     * Đệ quy lấy các node con để ẩn hiện
     */
    const changeVisibleTr = (data, expanded) => {
      let childNodes = data.childNodes;
      if (!childNodes || childNodes.length === 0) {
        return;
      }
      // data.expanded = expanded;
      childNodes.forEach((item) => {
        item.isHide = !expanded;
        changeVisibleTr(item, expanded);
      });
    };
    return { changeColumnResize, handlerResizeOn, toggleTree };
  },
  data() {
    return {
      //Data trong grid dùng để render
      datax: null,
      //Columns trong grid dùng để render
      columnx: [],
      //Mode cho phép copy dữ liệu hay không thực hiện với các event kéo thả cột,độ rộng,...
      selectedTextMode: false,
      //Trang hiện tại
      currentPage: 1,

      //Dòng đang được chọn
      rowSelected: {},
      //Kiểm tra data đã được load hay chưa
      dataLoaded: false,

      /**
       * index của row đang focus
       */
      indexOfRowFocused: 0,

      /**
       * index của row đang focus
       */
      oldIndexOfRowFocused: 0,

      /**
       * Vị trí hiển thị của box empty
       */
      emptyStyle: {
        top: 0,
        left: 0,
        display: 'none',
      },
      /**
       * Filter trên tiêu đề cột
       */
      filterHeader: [],
      /**
       * header render
       */
      headers: [],

      /*
      Cho show tất cả icon filter header lên
      Create: 20/05/2020
      Author: NNLAM
      */
      showAllIconFilter: false,

      /**
       * footer render
       */
      footers: [],

      /**
       * header render
       */
      firstLoad: true,

      //tổng số bản ghi ( trường hợp query local)
      totalCount: null,
      /**
       * giá trị style left của cột serial
       */
      serialOffsetLeft: '0',
      /**
       * Có cột lock
       */
      hasLockColumn: false,
      /**
       * Có đang sử dụng phím tắt để chọn nhanh các bản ghi hay không
       */
      shortKeyForQuickSelect: false,
      /**
       * Những bản ghi dc chọn nhanh từ shortkey
       */
      shortkeyQuickSelectedData: [],
      pageSizeInternal: 0,
      /**
       * có scroll ngang không
       */
      hasScrollX: false,
      /**
       * có scroll dọc không
       */
      hasScrollY: false,
      /**
       * Check xem có đã check all hay ko
       */
      checkedAll: false,
      /**
       * Cho phép người dùng tùy chỉnh cột lock
       * Mặc định là true
       */
      lockable: {
        type: Boolean,
        default: true,
      },
      /**
       * Đánh dấu checkboxall trên header đang trạng thái trung gian
       */
      isTempState: false,
    };
  },
  computed: {
    /**
     * Số lượng cột shimmer
     * Hiện tại chưa sử dụng
     */
    shimmerColumn() {
      const me = this;
      let res = [];
      if (me.multiple) {
        res.push({
          offset: 0,
          lock: me.hasLockColumn,
        });
      }

      if (me.serial) {
        res.push({
          offset: me.multiple ? 60 : 0,
          lock: me.hasLockColumn,
        });
      }

      if (Array.isArray(me.columnx)) {
        me.columnx.forEach((item) => {
          res.push({
            offset: item.stickyOffset,
            lock: item.lock,
          });
        });
      }

      if (me.$slots['widget-body']) {
        res.push({
          offset: 0,
          lock: me.hasLockColumn,
        });
      }

      return res;
    },
    //Kiểm tra có lắng nghe xử lý sự kiện dblick hay không? nếu có thì đổi icon thành pointer
    checkListenerDbClick() {
      if (
        this._events &&
        this._events.dblclick &&
        this._events.dblclick.length > 0
      ) {
        return true;
      }
      return false;
    },
    //Sự kiện từ 1 dòng dữ liệu emit ra ngoài
    //Created by LTDAT(18.06.2020)
    listeners() {
      const me = this;
      return {
        drilldownClick: (metaData, event) => {
          if (event) {
            event.target.focus();
          }
          this.$emit('drilldownClick', metaData);
        },

        //TVLOI 22.05.2021 Event Click vào cộtđại diện cho nhiều dòng chi tiết
        viewMoreDetails: (metaData, event) => {
          if (event) {
            event.target.focus();
          }
          this.$emit('viewMoreDetails', metaData);
        },

        // dtnga3 (14.07.2022) Hiển thị form chi tiết khi click vào ô (nếu có config linkedForm)
        viewLinkedForm: (col, dataRow, event) => {
          if (event) {
            event.target.focus();
          }
          this.$emit('viewLinkedForm', col, dataRow);
        },

        // emit event hover vào 1 dòng
        mouseover: (dataRow, event) => {
          me.$emit('rowmouseover', dataRow, event);
        },
        // emit event thực hiện click 1 dòng
        rowactionclick: (command, dataRow, event) => {
          me.$emit('rowactionclick', command, dataRow, event);
        },

        // emit event nhấn key
        keydown: (dataRow, event) => {
          me.row_keydown(dataRow, event);
          me.$emit('keydown', dataRow, event);
        },

        // emit event khi lựa chọn selectbox của 1 dòng
        clickMultiple: (dataRow, checked) => {
          me.clickMultiple(dataRow, checked);
        },
      };
    },
    // //Set style cho grid độ rộng,...
    gridViewStyle() {
      if (this.maxHeight) {
        return { 'max-height': this.maxHeight };
      } else {
        return null;
      }
    },

    /**
     * datax : dữ liệu của bảng dùng để xử lý trong base
     */
    dataEmpty() {
      // return false;
      if (this.datax && this.datax.length > 0) {
        return false;
      } else return true;
    },

    /**
     * đếm số lượng các cột có thuộc tính lock
     */
    lockCount() {
      let count = this.multiple ? 1 : 0;
      if (this.columnx) {
        for (let i = 0; i < this.columnx.length; i++) {
          let col = this.columnx[i];
          if (!col.lock) {
            break;
          }
          count++;
        }
      }
      return count;
    },
    stickeyCountClass() {
      let count = this.lockCount;
      if (count > 0) {
        if (this.serial) {
          count++;
        }

        return ['sticky', count].join('-');
      }
      return null;
    },
    //Style tính lại tọa độ cho footer khi có pagination
    /**
     * pagination : có hiện thị pagination hay không, được truyền từ props
     * footer : có sử dụng footer hay không, được truyền từ props
     */
    bottomFooter() {
      const me = this;
      if (me.pagination && me.footer) {
        return {
          bottom: '46px',
        };
      } else {
        return {
          bottom: '0px',
        };
      }
    },
  },
  /**
   *
   */
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        let me = this;
        // this.checkHasScrollY();
        if (me.datax != me.data) {
          // Gán giá trị data mới để thực hiện render
          me.initData(newVal);
          // Nếu là lần đầu được render thì thực hiện
          if (me.firstLoad && newVal.length > 0) {
            // Hàm xử lý nếu set mặc định lựa chọn dòng đầu tiên
            me.autoSelectedFirstRow(window.event);
            // Gán lại cờ đánh dấu là đã render lần đầu, lần sau không chạy lại nữa
            me.firstLoad = false;
          }
          if (me.groupField) {
            // me.$nextTick(() => {
            //   me.defaultExpand();
            // });
          }
          // check selected các bản ghi khi mà load lại trang hoặc search làm thay đổi data grid
          // selected : mảng chứa các phần tử đã được lựa chọn trong bảng
          if (Array.isArray(me.selected) && me.selected.length > 0) {
            // Gán cờ đánh dấu khi checkbox được chọn là checkbox nằm trên header (lựa chọn tất cả)
            me.checkedAll = me.isCheckedMultiple(me.selected);
          }
        }

        //nếu không có dữ liệu tính toán vị trí hiển thị của box empty
        //control chưa render thì cũng k xử lý
        if ((!newVal || newVal.length === 0) && me.$el) {
          me.$nextTick(() => {
            // let scroll = me.$refs.content;
            // if (scroll) {
            //   let scrollPos = scroll.getBoundingClientRect();
            //   me.emptyStyle = {
            //     top: [scrollPos.top + scrollPos.height / 2 - 95, 'px'].join(''),
            //     left: [scrollPos.left + scrollPos.width / 2 - 125, 'px'].join(
            //       ''
            //     ),
            //   };
            // }
          });
        }
      },
    },
    searchText: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.triggerSearch();
        }
      },
    },
    pageSize: {
      immediate: true,
      handler(newVal, oldVal) {
        // this.$emit("pageSize", newVal);
        this.pageSizeInternal = newVal;
      },
    },
    pageTotal: {
      immediate: true,
      handler(newVal, oldVal) {
        this.totalCount = newVal;
      },
    },
    /**
     * Nếu là cột động thì init lại cột khi bị thay đổi
     * @author: BMThang(28/02/2023)
     */
    columns(newVal) {
      if (this.isDynamicColumns === true) {
        this.initColumns(newVal);
      }
    },
    selected: {
      handler(newVal, oldVal) {
        //Do checkedAll là v-model của ô checkbox nên phải đợi khi flush hết job thay đổi của ô khi click mới thực hiện check lại xem đã check hết bản ghi trên grid chưa
        //NCPHUOC 11/07/2022
        nextTick(() => {
          setTimeout(() => {
            this.checkedAll = this.isCheckedMultiple(newVal);
          }, 100);
        });
      },
    },
  },
  /**
   * Hàm khởi tạo grid khởi tạo column vào data
   * Created by LTDAT 16.06.2020
   */
  created() {
    const me = this;
    me.initColumns();
    me.initData();
    document.addEventListener('click', me.clickOutGrid);
    window.addEventListener('resize', me.windowResize);
  },
  beforeUnmount() {
    const me = this;
    document.removeEventListener('click', me.clickOutGrid);
    window.removeEventListener('resize', me.updateSize);
  },
  methods: {
    test(e) {
      console.log(e);
    },

    /**
     * hàm xử lý khi focus vào 1 row
     */
    onFocusRow(dataRow, event) {
      const me = this;
      // nếu row được lựa chọn khác với row được focus hiện tại thì thực hiện
      if (
        me.rowSelected &&
        me.rowSelected.data != dataRow &&
        !me.shortKeyForQuickSelect
      ) {
        // Lấy ra vị trí của row vừa được chọn
        let indexRow = me.datax.findIndex((item) => item == dataRow);
        me.rowSelected = {
          data: dataRow,
          index: indexRow,
        };
        // Thực hiện focus vào row vừa được chọn
        event.target.focus();
      }
    },

    /**
     * Hàm xử lý khi click vào 1 row
     * dataRow : dữ liệu của row đó
     */
    onClickRow(dataRow, event) {
      const me = this;
      // Nếu không xử dụng phím tắt để lựa chọn bản ghi (shortKeyForQuickSelect)
      if (event && !me.shortKeyForQuickSelect) {
        // Lưu index của row focus cũ
        me.oldIndexOfRowFocused = me.indexOfRowFocused;
        // Lấy ra index của row focus mới
        me.indexOfRowFocused = me.datax.findIndex((item) => item == dataRow);
        // Thực hiện focus vào row mới
        event.target.focus();
        if (me.multiple && !event.target.closest('.ms-td.multiple-cell')) {
          this.$emit('onClickRowCustom', dataRow, event);
        }
      }
      // Nếu không hiển thị checkbox để lựa chọn
      if (!me.multiple) {
        //me.selected = dataRow;
        // Gán lại data và index của row đang được chọn
        me.rowSelected.data = dataRow;
        me.rowSelected.index = me.datax.findIndex((item) => item == dataRow);
        this.$emit('onClickRowCustom', dataRow, event);
      }
    },
    /**
     * Kiểm tra xem tất cả dữ liệu có đang được check hay không
     * created by LTDAT 25.06.2020
     * modify by nnlam 05/05/2021
     */
    isCheckedMultiple(selected) {
      const me = this;
      if (selected) {
        // if (selected.length === me.datax.length) {
        //   const found = selected.some((r) => me.datax.indexOf(r) < 0);
        //   if (found) return false;
        // }
        let data = this.datax.filter((i) => !i.isDisabledCheckBox); //tìm tất cả bản ghi trên page mà ô checkbox k bị disabled

        //Nếu ko có paging thì check luôn length để kiểm tra selected hết
        if (!me.pagination) return selected.length === data.length;
        //ĐVThi 19/01/2021: sửa lỗi TA khi me.datax null thì đoạn code này văng lỗi TA
        //Nếu có rowspangroup thì thực hiện lọc ra các dòng master ở đầu
        if (this.rowSpanGroup) {
          data = this.groupDataRowSpan.filter(
            (x) => x[`rowspan-${this.groupField[0]}`]
          );
        }
        if (data && data.length != 0) {
          if (
            selected.length >= data.length &&
            data.every((item, index) => {
              return selected.findIndex(
                (dataRow) => dataRow[me.idField] === item[me.idField]
              ) === -1
                ? false
                : true;
            })
          ) {
            this.isTempState = false; // Bỏ trạng thái trung gian
            return true;
          }else {
            // Check nếu có dữ liệu được chọn trong trang thì bật trạng thái trung gian
            if (data.some((item, index) => {
              return selected.findIndex((dataRow) => dataRow[me.idField] === item[me.idField]) === -1
                ? false
                : true;
            })) {
              this.isTempState = true;
            } else {
              this.isTempState = false;
            }
            return false;
          }
        } else {
          return false;
        }
      }
    },
    /**
     * Tính toán xem có scroll ngang
     */
    updateHasScrollX() {
      const me = this,
        // Lấy ra document của content grid
        content = me.$refs.content;
      let scroll = false;
      // nếu độ rộng của content grid lớn hơn độ rộng của chính grid scroll ngang
      if (
        content &&
        content.clientWidth < content.firstElementChild.clientWidth
      ) {
        scroll = true;
      }

      me.hasScrollX = scroll;
    },

    /**
     * Chuyển về trang chỉ định
     */
    setPage(page) {
      this.currentPage = page;
    },
    /**
     * Hiển thị text tính tổng theo định dạng format
     * @param {Object} col cấu hình cột
     * @author NVLAM 10.12.2020
     */
    getSummaryDisplay(col, rowIndex, colIndex) {
      const me = this;
      let dataRender = '';
      if (me.summaryData) {
        // Lấy ra giá trị của summary theo từng trường trong data
        dataRender = me.summaryData[col.dataField];
      } else {
        // Lấy ra style tương ứng với các kiểu giá trị
        dataRender = col.summaryType
          ? summaryUtil.doFunction(
            me.datax,
            col.summaryType,
            col.dataField,
            col.dataFormat,
            this.totalCount || this.datax.length
          )
          : col.footerText;
      }
      //Return ngay nếu không cấu hình summary hoặc ko có dữ liệu
      if (!dataRender && col.summaryType && me.summaryData) return '';
      //Mặc định luôn không format cột đầu tiên do cột
      if (colIndex === 0) return dataRender;
      // Thực hiện bind giá trị của summary dựa theo kiểu dữ liệu được config trong cột
      let value = me.$ms.format.formatData(dataRender, {
        formatType: col.dataFormat || col.formatType,
        optionFormat: col.optionFormat,
      });
      return value == '--' || value == '-' ? null : value;
    },
    /**
     * Hàm chọn dòng đầu tiên
     * ischeckbox: có tích chọn vào ô checkbox không, mặc định là không và chỉ đơn thuần là click vào dòng đầu tiên
     * created by nnlam 06.03.2021
     */
    autoSelectedFirstRow(ischeckbox) {
      let me = this;
      me.$nextTick(() => {
        if (me.datax.length > 0) {
          if (ischeckbox && me.isCheckFirstRow) {
            // Gán lại vị trí và dữ liệu của row đang được focus là dòng đầu tiên
            me.indexOfRowFocused = 0;
            me.rowSelected = { data: me.datax[0], index: 0 };
          }
          setTimeout(() => {
            let trFirst = me.$el.querySelector('.ms-tbody.data tr');
            // isAutoFocusFirstRow : có tự động focus vào dòng đầu tiên không, được truyền vào thông qua props
            if (trFirst && me.isAutoFocusFirstRow) {
              // thực hiện focus vào dòng đầu tiên
              trFirst.focus();
            }
            me.$emit('firstLoad', me.datax[0]);
          }, 200);
        }
      });
    },
    /**
     * Sự kiện window resize
     */
    windowResize() {
      this.updateSize();
    },
    /**
     * Cập nhật footer container with
     * phải đợi data render xong để xem có scroll dọc không còn update lại width
     * NXCHIEN 22/06/2022: Check width != 0 cho TH grid đang bị ẩn
     */
    updateFooterContainer() {
      const me = this,
        width = me.$refs.content?.clientWidth;
      if (width && me.$refs.tableFooter) {
        me.$refs.tableFooter.style.width = width + 'px';
      }
    },
    /**
     * Hàm Cập nhật lại giao diện khi có scroll hay khi độ rộng của data dài hơn độ rộng mặc định của cột
     * Created by LTDAT
     */
    updateSize() {
      const me = this;
      me.$nextTick(() => {
        // me.checkHasScrollY();
        if (me.$refs.tr && me.$refs.tr.length > 0) {
          // columnx config của cột
          // duyệt qua tất cả các config cột để kiểm tra độ rộng của data dài hơn độ rộng mặc định của cột
          me.columnx.forEach((col, index) => {
            let changeMinWidth = false;
            me.$refs.tr.forEach((item) => {
              if (
                item.$refs[`text-${col.dataField}`] &&
                item.$refs[`text-${col.dataField}`].length > 0
              ) {
                // Lấy ra độ rộng data của cột
                let textSpan =
                  item.$refs[`text-${col.dataField}`][0].offsetWidth;
                // Nếu độ rộng hiện tại của cột nhỏ hơn độ rộng của phần content + 20px thì thay đổi min width của cột
                if (col._width < textSpan + 20) {
                  changeMinWidth = true;
                  // Nếu độ rộng của thẻ th khác độ rộng của thẻ td mà nó chứa => độ rộng của content đang vượt quá độ rộng của cột
                  if (
                    me.$refs.th[index].$el.offsetWidth !=
                    item.$refs[`td-${col.dataField}`][0].offsetWidth
                  ) {
                    // Thay đổi minwidth và width của cột bằng với phần content của cột đó
                    col['_minWidth'] =
                      item.$refs[`td-${col.dataField}`][0].offsetWidth;
                    col['_width'] =
                      item.$refs[`td-${col.dataField}`][0].offsetWidth;
                  }
                }
              }
            });
            // Nếu không cần thay đổi độ rộng cột thì dữ nguyên độ rộng
            if (changeMinWidth == false) {
              col['_minWidth'] = col._width;
            }
          });
          // Xử lý các thẻ tr dùng để nhóm khi có group
          if (me.$refs.trGroup) {
            me.$refs.trGroup.forEach((item, index) => {
              let tdGroup = item.querySelector('.td-group');
              if (tdGroup) {
                let colspan = tdGroup.getAttribute('colspan');
                let tdGroupWidth = 0;
                if (me.$refs.th && colspan) {
                  let i = me.multiple ? 0 : 1;
                  // Ứng với giá trị của colspan => số lượng thẻ th con của thẻ tr group đang chứa
                  // Duyệt qua tất cả các thẻ th con để tính độ rộng của các phần tử con này
                  for (i; i <= colspan; i++) {
                    let thCurrentElement = me.$refs.th[i];
                    if (thCurrentElement) {
                      // Tính chiều rộng của tất cả các phần tử con được group bởi thẻ tr cha
                      tdGroupWidth += thCurrentElement.$el.offsetWidth;
                    }
                  }
                }
                // Gán lại chiều rộng của thẻ group cha bằng với chiều rộng của các phần tử con
                tdGroup.style.width = tdGroupWidth + 'px';
                tdGroup.style.maxWidth = tdGroupWidth + 'px';
              }
            });
          }
        }

        //tính toán xem có scroll ngang không
        me.updateHasScrollX();

        //cập nhật footer
        if (me.footer) {
          me.initFooterColumn(me.columnx);
          this.updateFooterContainer();
        }
      });
    },
    // /**
    //  * Hàm trước thực hiện transition bắt đầu render.
    //  * Created by LTDAT
    //  */
    // beforeRenderContent() {
    //   const me = this;
    //   me.updateSize();
    // },
    /**
     * Thực hiện khi ấn vào ngoài grid loại bỏ row đang chọn
     * Created by LTDAT
     *  */
    clickOutGrid(event) {
      const me = this;
      if (event.target.closest('.ms-grid-viewer') != me.$el) {
        //me.rowSelected = {};  nnlam bỏ đi vì khi click ra ngoài thì những dòng được chọn mong muốn vẫn giữ nguyên focus
      }
    },
    /**
     * Hàm thực hiện việc sort trên grid
     * @params col cột được thực hiện sắp sếp
     * @params mode gồm null,DESC,ASC
     * created by LTDAT
     */
    sort(col, mode) {
      const me = this,
        pageSize = me.getPageSize();
      // Thực hiện sort dữ liệu gọi API
      if (me.sortMode == 'remote') {
        let payload = {
          skip: (me.currentPage - 1) * pageSize,
          take: pageSize,
        };
        if (mode != me.$ms.constant.SortStatus.none) {
          payload.sort = [
            col.dataField,
            mode == me.$ms.constant.SortStatus.desc ? 'DESC' : 'ASC',
          ].join(' ');
        }
        // Hàm xử lý khi thực hiện render lại data
        me.listenersLoadData(payload);
      } else if (me.datax && me.datax.length > 0) {
        let data = null;
        // Thực hiện sort dữ liệu tĩnh ngay trên grid
        if (me.queryMode == 'local' && typeof me.filterFn == 'function') {
          data = me.filterFn();
          me.totalCount = data ? data.length : 0;
        } else {
          data = [...me.internalDataSource];
        }
        //hàm sort
        function compare(a, b) {
          if (a[col.dataField] < b[col.dataField])
            return mode == me.$ms.constant.SortStatus.desc ? 1 : -1;
          if (a[col.dataField] > b[col.dataField])
            return mode == me.$ms.constant.SortStatus.asc ? 1 : -1;
          return 0;
        }

        //thực hiện sort
        if (mode != me.$ms.constant.SortStatus.none) {
          data = data.sort(compare);
        }

        //nếu có phân trang thì phân trang
        if (me.pagination) {
          /**
           * min : index của phần tử bắt đầu khi phân trang
           * max : index của phần tử kết thúc phần trang
           */
          let min = Math.ceil((me.currentPage - 1) * pageSize),
            max = min + pageSize;
          // Thực hiện gán lại dữ liệu khi thay đổi phân trang
          // Chỉ lấy các giá trị nằm trong khoảng phân trang để render dữ liệu
          me.datax = data.filter((item, index) => {
            return index >= min && index < max;
          });
        } else {
          // Nếu không có phần trang thì gán lại toàn bộ data của bảng sau khi sort
          me.datax = data;
        }
      }
    },
    getPageSize() {
      return this.pageSizeInternal || 10;
    },
    //Kiểm tra xem grid có scroll hay không để chỉnh lại size của grid cho đúng
    //Created by LTDAT (29.07.2020)
    checkHasScrollY() {
      const me = this;
      me.$nextTick(() => {
        // Lấy document của toàn bộ phần content bảng
        let content = me.$refs.content;
        if (content) {
          setTimeout(() => {
            // Lấy chiều cao của bảng
            let height = content.clientHeight;
            // Thực hiện tính toán lại chiều cao của bảng nếu có paging / footer
            // console.log(height, content.firstElementChild.clientHeight)
            // if (me.pagination) {
            //   height -= 28;
            // }
            // if (me.footer) {
            //   height -= 28;
            // }
            if (height < content.firstElementChild.clientHeight) {
              me.hasScrollY = true;
            } else {
              me.hasScrollY = false;
            }
            let x = 1;
          }, 100);
        }
      });
    },

    /**
     * Update sticky top cho grid dạng group
     * HTHIEP 19.04.2022
     */
    updateStickyTopGroup() {
      if (this.headers?.length > 1) {
        //lấy thông tin tr cuối cùng
        const lastItems = this.headers[this.headers?.length - 1];
        if (lastItems?.length > 0) {
          //lấy thông tin height của 1 thẻ tr dùng để làm căn cứ set top
          const trHeight = this.$el
            .querySelector('.ms-tr')
            ?.getBoundingClientRect()?.height;

          //Lấy ra cột group để tiến hành set top
          const groupItems = lastItems.filter((x) => x.group);
          groupItems.forEach((item) => {
            const th = this.$el.querySelector(
              `.ms-th[field="${item.dataField}"]`
            );
            if (th) {
              const le = this.headers?.length - 1;
              th.style.top = `${trHeight * (this.headers?.length - 1)}px`;
            }
          });
        }
      }
    },

    /**
     * Hàm lắng nghe sự kiến thay đổi trang nếu thay đổi thì emit sự kiện load data mới ra ngoài
     * @param payload dữ liệu thông tin trang gửi ra ngoài
     *  */
    //Created by LTDAT(27.07.2020)
    listenersLoadData(payload) {
      const me = this;

      if (me.pagination) {
        me.currentPage = payload.skip / payload.take + 1;
        //Nếu thực hiện lấy data dưới local thì thức hiện lưu dữ liệu vào internalDataSource và phân trang local
        if (me.queryMode == 'local' && me.pagination) {
          // commonFn.genVKeyValue(me.internalDataSource);
          me.datax = me.getItemPagination();
        }
      }
      // Thực hiện đưa scroll lên đầu sau khi load lại params
      me.$refs.content.scrollTop = 0;
      me.$emit('loadData', payload);
    },

    /**
     * Kiểm tra xem cột được check hay không ?
     * duyệt trong data nếu có chưa dữ liệu của dòng tương ứng thì return true ngược lại false
     * @param dataRow dữ liệu của dòng được check
     * Created by LTDAT 24.06.2020
     *  */
    isSelected(dataRow) {
      const me = this;
      if (me.selected && me.selected.length > 0) {
        // Sử dụng idField (tên trường khóa chính được truyền từ props) để kiểm tra row đã được select hay chưa
        return this.selected.findIndex(
          (x) => x[me.idField] === dataRow[me.idField]
        ) === -1
          ? false
          : true;
      }
      return false;
    },
    /**
     * Kiểm tra xem row có disable checkbox k
     * @param dataRow dữ liệu của dòng được check
     * Created by nnlam 24.06.2020
     *  */
    funDisabledCheckedMultipleTbody(dataRow) {
      let me = this;
      if (typeof me.disabledCheckedMultipleTbody == 'function') {
        return me.disabledCheckedMultipleTbody(dataRow);
      }
      return me.disabledCheckedMultipleTbody;
    },
    /**
     * Hàm xử lý sự kiện khi click vào ô check multiple
     * @param dataRow dữ liệu của dòng được chọn
     * @param checked true/false trang thái của checkbox tương ứng
     * Created by LTDAT (30.05.2020)
     */
    clickMultiple(dataRow, checked) {
      const me = this;
      // tạo biến VModel để thực hiện xử lý dữ liệu trong hàm
      let VModel = me.selected ? [...me.selected] : [];
      // Lấy index của row vừa được chọn thông qua idField(trường khóa chính)
      const index = VModel.findIndex(
        (x) => x[me.idField] === dataRow[me.idField]
      );
      if (!checked) {
        // nếu trường được chọn là uncheck thì bỏ trường đó ra khỏi các dữ liệu được chọn
        VModel = VModel.filter((x) => x[me.idField] !== dataRow[me.idField]);
      } else {
        // nếu dòng vừa chọn chưa được check thì đưa vào giá trị mới
        if (index === -1) {
          VModel.push(dataRow);
        }
      }
      //Đoạn này ko cần nữa vì đã watch selected rồi
      // const isCheckedAll = me.isCheckedMultiple(VModel);
      // me.checkedAll = isCheckedAll;
      me.$emit('update:selected', VModel);
    },
    /**
     * Hàm xử lý sự kiện khi click vào ô check multiple dùng phím tắt
     * @param dataRow dữ liệu của dòng được chọn
     * Created by NNLAM (30.05.2020)
     */
    clickMultipleByShorKey(list) {},

    //Lấy dữ liệu của 1 trang khi phân trang local
    //Created by LTDAT(18.06.2020)
    getItemPagination() {
      let me = this,
        pageSize = me.getPageSize(),
        // Lấy index của phần tử bắt đầu và kết thúc dựa vào paging
        min = Math.ceil((me.currentPage - 1) * pageSize),
        max = min + pageSize;

      let data = null;
      // Thực hiện phân trang dữ liệu goi API
      if (me.queryMode !== 'remote') {
        // Nếu thực hiện filter tĩnh, không gọi lại API thì sử dụng localFilterData
        data = me.localFilterData;
      } else {
        // nếu thực hiện filter động, gọi API thì sử dụng internalDataSource
        data = me.internalDataSource;
      }

      data = data || [];
      // Lấy ra các giá trị nằm trong khoảng index của paging vừa tính toán
      let dataPagination = data.filter((item, index) => {
        return index >= min && index < max;
      });
      return dataPagination;
    },

    //Xử lý sự kiện resize col trên grid
    //created by LTDAT(29.05.2020)
    //cmt by: nnlam 24/02/2021: bỏ đi vì thừa gây xấu khi mà click vào resize thì làm change width toàn bộ column luôn
    resizeActive() {
      //Không cho phép bôi đen text
      // this.selectedTextMode = true;
      // if (this.$refs.th) {
      //   let listTh = this.$refs.th;
      //   if (listTh && listTh.length > 0) {
      //     listTh.forEach((item) => {
      //       if (item == listTh[listTh.length - this.indexFlexRight]) {
      //         item.updateColWidth(true);
      //       } else {
      //         item.updateColWidth(false);
      //       }
      //     });
      //   }
      // }
    },
    //Đóng sự kiện resize cột trên grid
    //created by LTDAT(29.05.2020)

    resizeClose(col) {
      const me = this;
      //Cho phép bôi đên text
      me.selectedTextMode = false;
      col.newWidth = col._width;
      me.$emit('resizeCol', col);

      //tính toán xem có scroll ngang không
      me.updateHasScrollX();

      //cập nhật footer
      if (me.footer) {
        me.initFooterColumn(me.columnx);
        me.updateFooterContainer();
      }
    },
    /**
     * Set giá trị default cho cấu hình cột
     * Created by LTDAT(17.07.2020)
     */
    setDefaultFieldColumn(columns) {
      //Nếu không cấu hình field hiện thị thì mặc định là true
      const me = this;
      columns.forEach((item) => {
        //món này là lock range nên sẽ không đặt cấu hình từng cột mà ăn chung theo grid
        item.lockable = me.lockable;

        if (item.visible != false) {
          item.visible = true;
        }

        //gắn giá trị columnType theo formatType
        if (!item.columnType) {
          me.setDefaultColumnType(item);
        }

        //nếu không chỉnh định thì để align mặc dịnh theo format type
        if (!item.align) {
          switch (item.columnType) {
            case 'ColumnNumber':
              item.align = 'right';
              break;
            case 'ColumnBoolean':
            case 'ColumnDateTime':
              item.align = 'center';
              break;
          }
        }
        item['_width'] = item.width;
      });
    },

    onDraggableChanged(event) {
      const me = this;
      me.$emit('onDraggableChanged', event);
    },

    /** Lấy ra các column có thuộc tính visible = true
     * Created by LTDAT 17.07.2020
     * */
    getVisibleColumn(columns) {
      return columns.filter((item) => {
        return item.visible == true;
      });
    },
    /**
     * Khởi tạo dữ liệu ban đầu cho grid
     * columns truyền vào mặc định là columns trong props có thể truyền cấu hình khác từ ngoài vào
     */
    initColumns(columns) {
      const me = this;
      me.columnx = [];
      me.$nextTick(() => {
        // Khởi tọa columnx để xử lý columns ở trong base
        me.columnx = columns || me.columns || [];
        if(me.isShowRowAction && me.rowActions?.length) {
        me.columnx.push({
          width: 100,
          caption: me.headerActionText,
          alignHeader: 'center',
          align: 'center',
          columnType: me.$ms.constant.ColumnType.Action,
        })
      }
        // Set giá trị default cho cấu hình cột
        me.setDefaultFieldColumn(me.columnx);
        me.columnx = me.getVisibleColumn(me.columnx);
        if (!me.columnx) {
          me.columnx = [];
        }
        // Kiểm tra có cột nào cho phép resize hay không
        let hasFlex = me.columnx.some((item) => {
          return item.autoResize;
        });
        if (
          hasFlex == false &&
          me.columnx[me.columnx.length - me.indexFlexRight]
        ) {
          // me.resizeActive();
          if (me.columnx && me.columnx[me.columnx.length - me.indexFlexRight]) {
            me.columnx[me.columnx.length - me.indexFlexRight][
              'autoResize'
            ] = true;
          }
        } else if (hasFlex == false && me.columnx.length == 1) {
          me.columnx[0]['autoResize'] = true;
        }

        //xử lý group header
        me.initHeader(me.columnx);

        //gán stickty left cho các cột sticky
        me.$nextTick(() => {
          //tính toán xem có scroll ngang không
          me.$nextTick(() => {
            me.updateHasScrollX();
          });

          me.updateStickyOffset();

          //tính toán xem có scroll ngang không
          me.updateHasScrollX();

          //nếu có footer thì sử lý
          if (me.footer) {
            setTimeout(() => {
              me.initFooterColumn(me.columnx);
              // me.updateFooterContainer();
            }, 300);
          }

          //HTHIEP 19.04.2022: Thêm xử lý sticky col cho group
          me.$nextTick(() => {
            this.updateStickyTopGroup();
          });
        });
      });
    },
    /**
     * @param columns Danh sách cột được truyền vào từ props
     * @des Xử lý tiêu đề cột
     * các cột có group giống nhau sẽ được xếp chung vào group
     */
    initHeader(columns) {
      const me = this,
        headers = [],
        sub = [];

      let groupMap = new Map();

      columns.forEach((item, i) => {
        if (item.group) {
          // Khi item có group
          // Nếu group của item chưa được khởi tạo
          if (!groupMap.has(item.group)) {
            // khởi tạo group (caption = item.group) -> push vào headers
            let group = {
              isGroup: true, // là group hay không
              colspan: 1, // kích thước group
              caption: item.group, // Tên group
              lock: false, // Có cố định không
              firstChild: item, // Lưu lại firstChild nếu group chỉ có 1 item thì gán lại
            };
            groupMap.set(item.group, headers.length); // key: group name, value: index của group trong headers
            headers.push(group); // push group vào headers
          } else {
            headers[groupMap.get(item.group)].colspan++; // Nếu đã có group của item.group rồi thì tăng kích thước group
          }
          sub.push(item);
        } else {
          // Khi item không có group -> push item vào headers
          headers.push(item);
        }
      });

      //duyệt xử lý các nhóm cột chỉ có 1 phần từ -> bỏ nhóm đi
      for (let i = 0; i < headers.length; i++) {
        let col = headers[i];
        if (col.colspan === 1) {
          let child = col.firstChild;
          headers[i] = child;
          sub.remove(child);
        }
        delete col.firstChild;
      }

      me.headers = sub.length > 0 ? [headers, sub] : [headers];
    },

    /**
     * Xử lý tiêu đề cột
     * Xử lý trường hợp có summaryType ở footer thì forces ô tổng :NCPHUOC 15/07/2022
     * columns : config của cột được truyền vào từ props
     */
    initFooterColumn(columns) {
      const me = this,
        // Khởi tạo biến để thực hiện xử lý dữ liệu
        footers = [],
        sub = [],
        // Lấy ra các thẻ theade
        thead = me.$refs.thead;

      let columx = JSON.parse(JSON.stringify(columns));
      let firstCol = null;
      // Nếu có giá trị config của cột thì thực hiện
      if (columx.length > 0) {
        // nếu có checkbox chọn nhiều hoặc cho phép hiển thị số dòng
        if (me.multiple || me.showTotalRecord) {
          columx.insertAt(0, {
            stickyOffset: 0, // Khoảng cách trái của cột
            colspan: 1, // Số cột con
            width: columx[0].stickyOffset, // Độ rộng của cột
            // summaryType: me.$ms.constant.SummaryType.RowCount,
            dataField: 'multiple',
            classes: 'footer-total-summary',
          });

          firstCol = columx[1];
          // gán giá trị mặc định cho cột summary là tính tổng
          if (!firstCol.summaryType) {
            firstCol.footerText = 'Tổng';
            firstCol.classes = 'footer-total-summary';
          }
        } else {
          if (me.footer && !columx[0].summaryType) {
            // columx[0].summaryType = me.$ms.constant.SummaryType.RowCount;
            columx[0].classes = 'footer-total-summary';
            columx[1].footerText = 'Tổng';
            columx[1].classes = 'footer-total-summary';
          }
        }
      }

      for (let i = 0; i < columx.length; i++) {
        let col = columx[i];
        //Nếu có multiple sẽ gộp 2 cột đầu tiên lại để hiển thị số tổng trên footer
        // Do cột đầu tiên là cột checkbox quá bé k hiển thị được
        // if (i === 1 && me.multiple) {
        //   continue;
        // }
        let item = {
          dataField: col.dataField, // tên field để bind giá trị cho footer
          align: col.align, // Căn lề giá trị của footer, mặc định là left
          formatType: col.formatType, // Kiểu của giá trị dùng để format
          footerText: col.footerText, // text của footer(VD tổng)
          summaryType: col.summaryType, // Kiểu của footer dùng để css
          stickyOffset: col.stickyOffset,
          colspan: col.colspan || 1,
          width: col.width,
          classes: col.classes,
        };

        if (thead) {
          let th = thead.querySelector(
            ['th[field="', col.dataField, '"]'].join('')
          );
          if (th) {
            item.width = th.getBoundingClientRect().width || col.width;
            if (me.lockCount > 0 && me.lockCount === i + 1) {
              item.width += 1; //+1 do border lock
            }
          }
        }
        footers.push(item);
      }

      //xử lý cột widget ở cuối
      if (me.$slots['widget-title-th'] || me.$slots['widget-title']) {
        let widget = thead?.querySelector('.widget-title');
        if (widget) {
          footers.push({
            dataField: 'widget',
            colspan: 1,
            width: widget.getBoundingClientRect().width,
            stickyRight: true,
          });
        }
      }
      me.footers = [footers];
    },
    /**
     * Cập nhật left cho các cột stickey
     */
    updateStickyOffset() {
      const me = this,
        ths = me.$el.querySelectorAll('.ms-th'),
        columns = me.columnx;
      let usingColumnSetting = false;

      let offset = 0;
      let f = 0;
      let width = 0;
      // Nếu cho phép hiển thị chekcbox lựa chọn
      if (me.multiple) {
        // Lấy ra chiều rộng của thẻ thẻ theader
        width = ths[f].getBoundingClientRect().width || 0;
        // trường hợp grid bị ẩn đi -> offset của ô checkbox bị = 0; (lưu ý trên form có 2 grid trên 2 ms-tap-item khác nhau thì grid ở tab không actice sẽ bị lỗi left sticky)
        if (width === 0) {
          usingColumnSetting = true;
          width = me.$ms.constant.StyleCheckBoxMulti.Width;
        }
        offset += width;
        f++;
      }

      // Nếu hiển thị cột số thứ tự
      if (me.serial) {
        // Gán giá trị cách trái cho STT
        me.serialOffsetLeft = offset ? [offset, 'px'].join('') : '0';
        width = ths[f].getBoundingClientRect().width || 0;
        // trường hợp grid bị ẩn đi -> offset của ô checkbox bị = 0; (lưu ý trên form có 2 grid trên 2 ms-tap-item khác nhau thì grid ở tab không actice sẽ bị lỗi left sticky)
        if (width === 0) {
          width = 60;
        }
        usingColumnSetting = true;
        offset += width;
        f++;
      }

      me.hasLockColumn = false;
      let i = 0;
      for (; i < me.columnx.length; i++) {
        let col = me.columnx[i];
        if (!col.lock) {
          break;
        }

        me.hasLockColumn = true;
        col['stickyOffset'] = offset;

        let pos = 0;
        if (!usingColumnSetting) {
          pos = ths[i + f].getBoundingClientRect();
        } else {
          pos = { width: columns[i + f - 1].width };
        }

        offset += pos.width;
      }

      //remove offset column not locked
      for (let j = i; j < me.columnx.length; j++) {
        let col = me.columnx[j];
        col['stickyOffset'] = null;
      }

      me.initFooterColumn(me.columnx);
    },

    //Xóa 1 phần tử trong data grid
    /**
     * item : phần tử bị xóa
     * datax : giá trị các phần tử của bảng
     */
    removeItem(item) {
      const me = this;
      // eslint-disable-next-line no-undef
      me.datax = _.remove(me.datax, (e) => {
        return e !== item;
      });
    },

    //Gán giá trị để render data có thể truyền từ ngoài vào
    /**
     * data : giá trị data được truyền vào từ props
     * datax : giá trị data để thực hiện việc xử lý dữ liệu trong base
     * internalDataSource : giá trị data phục vụ cho việc tìm kiếm, sắp xếp tĩnh mà không cần gọi API
     */
    initData(data = this.data) {
      const me = this,
        // Lấy độ dài của dữ liệu để thực hiện việc update vị trí của scroll
        updateScroll = !data != !me.datax || data.length != me.datax.length;
      // gán lại giá trị trung gian của data
      me.internalDataSource = null;
      if (data) {
        // Gán giá trị mới cho data trung gian để phục vụ cho search / sort
        me.internalDataSource = [...data];
      }
      //Nếu thực hiện lấy data dưới local thì thức hiện lưu dữ liệu vào internalDataSource và phân trang local
      if (me.queryMode !== 'remote' && me.pagination) {
        me.localFilter();
        // commonFn.genVKeyValue(me.internalDataSource);
        me.datax = me.getItemPagination();
      } else {
        //Lấy dữ liệu từ server
        //Tạm gán = props data sau gán = gì khác tính sau
        //ĐVThi 19/01/2021: sửa lỗi TA khi me.datax null thì đoạn code này văng lỗi TA
        if (me.internalDataSource) {
          me.datax = [...me.internalDataSource];
        }
        // commonFn.genVKeyValue(me.datax);
      }
      // Lưu cache lại dữ liệu data dùng để filter/sort tĩnh mà không cần gọi API
      me._cacheData = [...me.datax];
      // nếu có giá trị search
      if (
        this.searchText ||
        (this.filterObject && Object.keys(this.filterObject).length > 0)
      ) {
        // Thực hiện việc search trên bảng
        this.triggerSearch();
      }
      // update lại scroll khi dữ liệu của data thay đổi
      if (updateScroll) {
        me.$nextTick(() => {
          this.checkHasScrollY();
        });
      }
    },

    /**
     * Thực hiện search
     */
    triggerSearch() {
      // nếu có giá trị để search
      if (
        this.searchText ||
        (this.filterObject && Object.keys(this.filterObject).length > 0)
      ) {
        // Lấy giá trị dataFiled để thực hiện việc lọc
        const properties = this.columnx.map((x) => x.dataField);

        const data = [];
        //Cache lại những item đã được thêm vào để không cần duyệt mảng check
        const cacheExist = new Map();
        const idField = this.idField;
        const findParent = (currentItem) => {
          const isExist = cacheExist.get(currentItem[idField]);
          //Cache lại để đệ quy ko tìm vào item này nữa
          if (!isExist) {
            cacheExist.set(currentItem[idField], true);
          }

          if (currentItem.parentNode) {
            findParent(currentItem.parentNode);
          }
          //Thực hiện push ở sau để push các thằng cha vào trước
          if (!isExist) {
            data.push(currentItem);
          }
          return;
        };

        this.data.forEach((x) => {
          // Tìm kiếm các bản ghi hợp lệ thông qua properties
          let valid = commonFn.checkSearchText(x, properties, this.searchText);

          if (valid) {
            // lọc thêm theo bộ lọc khác
            if (
              this.filterObject &&
              Object.keys(this.filterObject).length > 0
            ) {
              // Tìm kiếm các bản ghi hợp lệ theo bộ lọc khác
              valid = commonFn.checkFilterObject(x, this.filterObject);
            }

            if (valid) {
              findParent(x);
            }
          }
          return valid;
        });

        // Gán lại data sau khi lọc để thực hiện lại render
        this.datax = data;
        // Gán lại số lượng phần tử sau khi lọc
        this.totalCount = this.datax ? this.datax.length : 0;
      } else {
        // Nếu xóa giá trị lọc thì lấy lại giá trị cũ ở trong cache ra
        this.datax = [...this._cacheData];
        this.totalCount = this.datax ? this.datax.length : 0;
      }
    },

    //Lấy dữ liệu của dòng được chọn
    //Created by LTDAT(16.06.2020)
    getRowSelected() {
      const me = this;
      return me.rowSelected;
    },

    //Xử lý sự kiện ấn phím trên row
    //Created by LTDAT(15.06.2020)
    // chưa sử dụng
    row_keydown(dataRow, e) {
      let me = this;
      // Lấy ra vị trí của row đang được lựa chọn
      let currentIndex = me.rowSelected.index;
      let tr = null;
      e = e || window.event;
      if (e.ctrlKey || e.shiftKey) {
        switch (e.which) {
          case 40: //down
            if (currentIndex < me.datax.length - 1 && !e.altKey) {
              // gán lại cờ đánh dấu đang sử dụng phím để search
              me.shortKeyForQuickSelect = true;
              // Gán giá trị thẻ tr là giá trị doc của row vừa chọn
              tr = this.$el.querySelector(
                `.ms-tbody.data tr[indexRow='${currentIndex}']`
              );
              currentIndex++;
              me.indexOfRowFocused = currentIndex;
              if (
                !me.shortkeyQuickSelectedData.includes(me.datax[currentIndex])
              ) {
                me.shortkeyQuickSelectedData.push(me.datax[currentIndex]);
              } else {
                me.shortkeyQuickSelectedData.remove(me.datax[currentIndex]);
              }
              me.rowSelected.data = me.datax[currentIndex];
              me.rowSelected.index = currentIndex;
              me.adjustScroll(currentIndex, tr, false);
              e.preventDefault();
            }
            break;
          case 38: //up
            if (currentIndex > 0 && !e.altKey) {
              me.shortKeyForQuickSelect = true;
              tr = this.$el.querySelector(
                `.ms-tbody.data tr[indexRow='${currentIndex}']`
              );
              currentIndex--;
              me.indexOfRowFocused = currentIndex;

              if (
                !me.shortkeyQuickSelectedData.includes(me.datax[currentIndex])
              ) {
                me.shortkeyQuickSelectedData.push(me.datax[currentIndex]);
              } else {
                me.shortkeyQuickSelectedData.remove(me.datax[currentIndex]);
              }
              me.rowSelected.data = me.datax[currentIndex];
              me.rowSelected.index = currentIndex;
              me.adjustScroll(currentIndex, tr, true);
              e.preventDefault();
            }
            break;
          case 32: //space
            e.target.focus();
            if (
              me.shortkeyQuickSelectedData &&
              me.shortkeyQuickSelectedData.length > 0
            ) {
              me.shortkeyQuickSelectedData.forEach((item) => {
                me.clickMultiple(item);
              });
            } else {
              me.clickMultiple(me.datax[currentIndex]);
            }
            e.preventDefault();
            break;
        }
      } else {
        switch (e.which) {
          case 40: //down
            if (currentIndex < me.datax.length - 1 && !e.altKey) {
              me.shortkeyQuickSelectedData = [];
              tr = this.$el.querySelector(
                `.ms-tbody.data tr[indexRow='${currentIndex}']`
              );
              tr.nextElementSibling.querySelector('td').click();
              currentIndex++;
              me.indexOfRowFocused = currentIndex;
              e.target.focus();
              me.rowSelected.data = me.datax[currentIndex];
              me.rowSelected.index = currentIndex;
              me.adjustScroll(currentIndex, tr, false);
              e.preventDefault();
            }
            break;
          case 38: //up
            if (currentIndex > 0 && !e.altKey) {
              me.shortkeyQuickSelectedData = [];
              tr = this.$el.querySelector(
                `.ms-tbody.data tr[indexRow='${currentIndex}']`
              );
              tr.previousElementSibling.querySelector('td').click();
              currentIndex--;
              me.indexOfRowFocused = currentIndex;
              e.target.focus();
              me.rowSelected.data = me.datax[currentIndex];
              me.rowSelected.index = currentIndex;
              me.adjustScroll(currentIndex, tr, true);
              e.preventDefault();
            }
            break;
          case 32: //space
            e.target.focus();
            if (
              me.shortkeyQuickSelectedData &&
              me.shortkeyQuickSelectedData.length > 0
            ) {
              let checkbox = me.$el.querySelectorAll(
                '.ms-tr.multi-row-selected .multiple-cell input[type="checkbox"]'
              );
              let checked = me.$el.querySelectorAll(
                '.ms-tr.multi-row-selected .multiple-cell input[type="checkbox"]:checked'
              );
              if (checked.length == 0 || checked.length == checkbox.length) {
                checkbox.forEach((item) => {
                  item.click();
                });
              } else {
                checkbox.forEach((item) => {
                  if (!item.checked) {
                    item.click();
                  }
                });
              }
            } else {
              me.clickMultiple(me.datax[currentIndex]);
            }
            e.preventDefault();
            break;
        }
      }
    },

    /**
     * Lựa chọn nhanh sử dụng key
     * Hiện tại chưa sử dụng
     */
    quickSelected(e) {
      let me = this;
      let oldIndex = me.oldIndexOfRowFocused || 0;
      // Lựa chọn nhanh sửa dụng nút shift
      if (e.shiftKey) {
        // Gán trạng thái mode lựa chọn nhanh = true
        me.shortKeyForQuickSelect = true;
        let trEvent = e.target.closest('.ms-tr');
        // Lấy ra thứ tự của row vu
        let newIndex = trEvent.getAttribute('indexrow');
        let start = oldIndex >= newIndex ? newIndex : oldIndex;
        let end = oldIndex >= newIndex ? oldIndex : newIndex;
        me.shortkeyQuickSelectedData = [];
        for (start; start <= end; start++) {
          me.shortkeyQuickSelectedData.push(me.datax[start]);
        }
      }
      if (e.ctrlKey) {
        me.shortKeyForQuickSelect = true;
        let trEvent = e.target.closest('.ms-tr');
        let newIndex = trEvent.getAttribute('indexrow');
        if (!me.shortkeyQuickSelectedData.includes(me.datax[oldIndex])) {
          me.shortkeyQuickSelectedData.push(me.datax[oldIndex]);
        }
        if (me.shortkeyQuickSelectedData.includes(me.datax[newIndex])) {
          me.shortkeyQuickSelectedData.remove(me.datax[newIndex]);
        } else {
          me.shortkeyQuickSelectedData.push(me.datax[newIndex]);
        }
      }

      document.onkeydown = function () {
        me.$el.classList.add('user-selected-none');
      };
      document.onkeyup = function () {
        me.shortKeyForQuickSelect = false;
        me.$el.classList.remove('user-selected-none');
      };
      document.onmouseup = function () {
        if (!me.shortKeyForQuickSelect) {
          me.shortkeyQuickSelectedData = [];
        }
      };
    },

    /**
     * Hủy trạng thái chọn nhanh dùng nút key
     * Hiện tại chưa sử dụng
     */
    destroyQuickSelected(e) {
      let me = this;
      if (me.shortKeyForQuickSelect) {
        me.shortKeyForQuickSelect = false;
      }
    },

    //Sự kiện ấn vào nút chọn tất cả bên trên header
    changeCheckedMultiple(e) {
      const me = this;
      // tạo biến để xử lý bên trong funtion
      let VModel = [...me.selected];
      // Lấy trạng thái của ô checkbox : true | false
      const checked =
        e.target.tagName.toLowerCase() === 'input' ? e.target.checked : false;

      //Lọc các bản ghi đã có và chưa có trong list selected để update lại
      // không cần gán lại allChecked do có v-model tự binding từ sự kiện click checkbox all
      if (!checked) {
        // Lấy ra các row không bị disable ô checkbox
        let data = me.datax.filter((i) => !i.isDisabledCheckBox);
        data.forEach((dataRow) => {
          // Lấy ra các row đã được check dựa vào idField
          // idField là khóa chính của data, được truyền vào qua props
          const existed = VModel.find(
            (x) => x[me.idField] === dataRow[me.idField]
          );
          // Loại bỏ các data đã được chọn
          if (existed) {
            VModel.remove(existed);
          }
        });
      } else {
        // Lấy ra các row không bị disable ô checkbox
        let data = me.datax.filter((i) => !i.isDisabledCheckBox);
        data.forEach((dataRow) => {
          // Lấy ra các row đã được check dựa vào idField
          // idField là khóa chính của data, được truyền vào qua props
          const existed = VModel.find(
            (x) => x[me.idField] === dataRow[me.idField]
          );

          if (!VModel.includes(existed)) {
            // Đẩy những dòng đang ở trạng thái chưa được chọn -> được chọn vào
            VModel.push(dataRow);
          }
        });
      }
      me.$emit('onCheckedAll', e.target.checked);
      // emit ra danh sách các phần tử đã được chọn mới
      me.$emit('update:selected', VModel);
    },

    /**
     * Thay đổi pageSize
     * @param value giá trị của pageSize được lựa chọn thông qua msPaging
     */
    changePageSize(value) {
      let me = this;
      //Nếu thực hiện lấy data dưới local thì thức hiện lưu dữ liệu vào internalDataSource và phân trang local
      // if (me.queryMode !== 'remote' && me.pagination) {
      this.pageSizeInternal = value;
      // me.$emit('update:pageSize', value);
      // Lấy lại dữ liệu mới thông qua paging
      me.datax = me.getItemPagination();
      // }
      this.$emit('changePageSize', value);
    },
    /**
     * Gán giá trị mặc định cho columnType của cấu hình cột
     * @param {Object} col: cấu hình cột
     * @author NVLAM 18.12.2020
     */
    setDefaultColumnType(col) {
      const me = this,
        FormatType = me.$ms.constant.FormatType;
      switch (col.formatType) {
        case FormatType.List:
          col.columnType = 'ColumnDropdown';
          break;
        case FormatType.Checkbox:
          col.columnType = 'ColumnBoolean';
          break;
        case FormatType.Text:
          if (col.columnType != 'ColumnDropdown') {
            col.columnType = 'ColumnText';
          }
          break;
        case FormatType.Number:
        case FormatType.Quantity:
        case FormatType.QuantityConvert:
        case FormatType.UnitPrice:
        case FormatType.UnitPriceOC:
        case FormatType.AmountOC:
        case FormatType.Amount:
        case FormatType.ExchangeRate:
        case FormatType.Rate:
        case FormatType.Allocation:
          col.columnType = 'ColumnNumber';
          break;
        case FormatType.Date:
          col.columnType = 'ColumnDateTime';
          break;
        case FormatType.DateTime:
        case FormatType.Time:
          col.columnType = 'ColumnDateTime';
          break;
        default:
          col.columnType = 'ColumnText';
          break;
      }
    },
    /**
     * Đọc điều kiện filter header
     */
    getFilterHeader(hasColumn) {
      let me = this,
        result = [],
        enumFilterHeader = me.$ms.constant.FilterOperator,
        columns = me.filterHeader; //me.columnx;
      for (let i = 0; i < columns.length; i++) {
        // Lấy ra từng config column
        let column = columns[i];
        // nếu columns đang có giá trị filter
        if (column.filter && column.filter.value !== column.filterIgnoreValue) {
          let item = null,
            // Lấy ra giá trị của filter
            filterValue = column.filter.value,
            // Lấy ra toán tử filter
            operator = column.filter.operator;
          switch (operator) {
            // Toán tử giữa
            case enumFilterHeader.Between:
              item = [
                {
                  field: column.isExtData
                    ? `JSON_UNQUOTE(JSON_EXTRACT(ExtData, '$.${column.dataField}'))`
                    : column.dataField,
                  operator: enumFilterHeader.GreaterThanEquals,
                  value: column.filter.from,
                },
                {
                  field: column.isExtData
                    ? `JSON_UNQUOTE(JSON_EXTRACT(ExtData, '$.${column.dataField}'))`
                    : column.dataField,
                  operator: me.$ms.constant.FilterHeader.LessThanEquals,
                  value: column.filter.to,
                },
              ];
              break;
            case enumFilterHeader.Null:
            // Toán tử null
            case enumFilterHeader.NotNull:
              item = {
                field: column.isExtData
                  ? `JSON_UNQUOTE(JSON_EXTRACT(ExtData, '$.${column.dataField}'))`
                  : column.dataField,
                operator: operator,
              };

              //với cột text sẽ fix giá trị để lên server sẽ xử lý thêm kiểm tra với giá trị trống ''
              switch (column.columnType) {
                case 'ColumnText':
                case 'ColumnDrilldown':
                  item.value = 'text';
                  break;
              }
              break;
            // Toán tử chứa
            case enumFilterHeader.Contains:
            // Toán tử không chưa
            case enumFilterHeader.Notcontains:
            // Toán tử bắt đầu với
            case enumFilterHeader.StartsWith:
            // Toán tử kết thúc với
            case enumFilterHeader.EndsWith:
              if (
                typeof filterValue !== 'undefined' &&
                filterValue !== null &&
                filterValue !== ''
              ) {
                item = {
                  field: column.isExtData
                    ? `JSON_UNQUOTE(JSON_EXTRACT(ExtData, '$.${column.dataField}'))`
                    : column.dataField,
                  operator: operator,
                  value: filterValue,
                };
              }
              break;
            default:
              switch (column.columnType) {
                case 'ColumnDateTime':
                  if (filterValue) {
                    item = {
                      field: column.isExtData
                        ? `JSON_UNQUOTE(JSON_EXTRACT(ExtData, '$.${column.dataField}'))`
                        : column.dataField,
                      value: filterValue, //moment(filterValue).format('YYYY-MM-DD'),
                      operator: operator,
                    };
                  }
                  break;
                default:
                  if (
                    typeof filterValue !== 'undefined' &&
                    filterValue !== null &&
                    filterValue !== ''
                  ) {
                    item = {
                      field: column.isExtData
                        ? `JSON_UNQUOTE(JSON_EXTRACT(ExtData, '$.${column.dataField}'))`
                        : column.dataField,
                      value: filterValue,
                      operator: operator,
                    };
                  }
                  break;
              }
              break;
          }

          //xử lý tình huống enum của cột không chứa giá trị thì khỏi filter
          if (
            item &&
            (column.enumName || column.enum) &&
            !Array.isArray(item)
          ) {
            let enumObj = me.$ms.constant[column.enumName || column.enum],
              hasValue = false;
            for (let i in enumObj) {
              if (enumObj[i] === item.value) {
                hasValue = true;
                break;
              }
            }

            if (!hasValue) {
              item = null;
            }
          }

          //Thêm xử lý lại đoạn Between
          if (item) {
            if (Array.isArray(item)) {
              for (let i = 0; i < item.length; i++) {
                const data = item[i];
                if (hasColumn) {
                  data.column = column;
                }
                if (column.nullToFail) {
                  data.nullToFail = column.nullToFail;
                }

                result.push(data);
              }
            } else {
              if (hasColumn) {
                item.column = column;
              }
              if (column.nullToFail) {
                item.nullToFail = column.nullToFail;
              }

              result.push(item);
            }
          }
        }
      }

      if (me.customFilter) {
        if (Array.isArray(me.customFilter)) {
          result = result.concat(me.customFilter);
        }

        /** Custom lọc grid */
        if (typeof me.customFilter == 'function') {
          result = me.customFilter(result);
        }
      }

      return result;
    },

    /**
     * lưu tất cả các cột đã đánh dấu là đang filter
     * Lưu giá trị các cột đang được filter
     */
    columnFilter({ col, value }) {
      let me = this;
      // kiểm tra cột được filter đã từng được filter hay chưa
      let check = me.filterHeader.filter((i) => i.dataField == col.dataField);
      // nếu cột được filter chưa nằm trong danh sách các cột filter thì đưa vào
      if (check.length == 0) {
        me.filterHeader.push(col);
      } else {
        me.filterHeader.forEach((item) => {
          // nếu cột đang filter đã nằm trong danh sách thì chỉ update lại dữ liệu của cột trong filterHeader
          if (item.dataField == col.dataField) {
            item = col;
            return;
          }
        });
      }

      //Xóa giá trị filterHeader
      if (!value) {
        // Nếu bỏ giá trị header thì bỏ cột đang được filter ra khỏi danh sách các cột đang được filter
        this.$nextTick(() => {
          me.filterHeader = me.filterHeader.filter(
            (i) => i.dataField !== col.dataField
          );
        });
      }

      // queryMode : trạng thái filter tĩnh không gọi lại API
      if (me.queryMode !== 'remote') {
        me.localFilter();
        // set lại currentPage trở về 1
        me.setPage(1);
        me.datax = me.getItemPagination();
      } else {
        me.$emit('filter', me.filterHeader);
      }
    },
    /**
     * Xử lý filter local
     * Hiện tại chưa sử dụng
     */
    localFilter() {
      const me = this;
      let data = [];
      // Duyệt qua tất cả các phần tử của grid
      for (let i = 0; i < me.internalDataSource.length; i++) {
        let record = me.internalDataSource[i];
        let f = true;
        for (let j = 0; j < me.columnx.length; j++) {
          // Duyệt qua tất cả các cột của grid
          let col = me.columnx[j];
          // nếu cột đang có giá trị filter thì thực hiện filter dữ liệu
          if (
            col.filter &&
            col.filter.value !== null &&
            typeof col.filter.value !== 'undefined' &&
            col.filter.value !== ''
          ) {
            const fn = this.genFilterFunction([
              { ...col.filter, ...{ property: col.dataField } },
            ]);
            let test = fn(record);
            // me.testFilter(
            //   col.filter.operator,
            //   record[col.dataField],
            //   col.filter.value
            // );
            if (!test) {
              f = false;
              break;
            }
          }
        }

        if (!f) {
          continue;
        }
        data.push(record);
      }

      me.localFilterData = data;
      me.totalCount = data.length;
    },
    styleColumn(col, dataRow, styleObject) {
      this.$emit('grid_styleColumn', col, dataRow, styleObject);
    },

    /**
     * hàm conver toán tử thành text: ví dụ "Contants" -> "Chứa"
     */
    buildOperatorText(operator) {
      let operatorText = this.$ms.commonFn.getEnumResource(
        operator,
        'FilterOperator'
      );
      if (operatorText) {
        operatorText = operatorText.toLocaleLowerCase();
      }
      return [' ', operatorText, ' '].join('');
    },
    /**
     * hàm build value filter
     * Hiện tại chưa sử dụng
     */
    buildValue(item) {
      if (
        item.filter &&
        (item.filter.operator == this.$ms.constant.FilterOperator.Null ||
          item.filter.operator == this.$ms.constant.FilterOperator.NotNull)
      ) {
        return '';
      }
      if (
        item.filter.value === 0 &&
        item.formatType != this.$ms.constant.FormatType.Enum
      ) {
        return '0';
      }
      let value = this.$ms.format.formatData(item.filter.value, {
        formatType: item.formatType,
        enumName: item.enum,
        dataRow: {},
      });
      return '"' + value + '"';
    },

    /**
     * hàm xóa 1 item filter
     */
    removeFilterItem(item) {
      let me = this;
      this.$nextTick(() => {
        me.filterHeader.remove(item);
      });
      if (
        !item.formatType ||
        item.formatType == me.$ms.constant.FormatType.Text ||
        item.formatType == me.$ms.constant.FormatType.None
      ) {
        item.filter.operator = me.$ms.constant.FilterOperator.Contains;
      } else {
        item.filter.operator = me.$ms.constant.FilterOperator.Equals;
      }
      item.filter.value = null;
      item.hasActionFilter = false;
      let th = me.$refs.th.filter((x) => x.col.dataField == item.dataField);
      if (th && th.length > 0) {
        th[0].removeFilter();
      }
    },
    /**
     * hàm bỏ lọc
     */
    clearAllFilter() {
      let me = this;
      //me.filterHeader.removeAll();
      me.filterHeader.forEach((item) => {
        if (
          !item.formatType ||
          item.formatType == me.$ms.constant.FormatType.Text ||
          item.formatType == me.$ms.constant.FormatType.None
        ) {
          item.filter.operator = me.$ms.constant.FilterHeader.Contains;
        } else {
          item.filter.operator = me.$ms.constant.FilterHeader.Equals;
        }
        item.filter.value = null;
        item.hasActionFilter = false;
        let th = me.$refs.th.filter((x) => x.col.dataField == item.dataField);
        if (th && th.length > 0) {
          th[0].removeFilter();
        }
      });
      me.filterHeader = [];
    },

    /**
     * thêm hàm thiết lập cột ẩn hiện cột trên grid để có thể gọi từ component sử dụng  grid
     * pvduy 02/04/2021
     */
    setColumnVisible(field, visible) {
      const me = this;
      let column = null;
      for (let i = 0; i < me.columns.length; i++) {
        let col = me.columns[i];
        if (col.dataField === field) {
          column = col;
          column.visible = visible;
          break;
        }
      }
      me.initColumns(me.columns);
    },
    //Lấy element scroll
    //Created by LTDAT (16.06.2020)
    getScroller() {
      if (this && this.$el && typeof this.$el.querySelector === 'function') {
        return this.$el.querySelector('.scroller');
      }
      return null;
    },
    /**
     * scroll theo phím up /down
     * @param {Bản ghi đang selected} typeAheadPointer
     * @param {dòng focus trước đó} trOld
     * @param {Scroll Lên hay xuống} scrollUp
     * CreatedBy NNLAM 16.06.2020
     */
    adjustScroll(typeAheadPointer = this.typeAheadPointer, trOld, scrollUp) {
      let scroller = this.getScroller();
      let tdHeight = this.$el.querySelector('td').offsetHeight;
      let tr = this.$el.querySelector(
        `.ms-tbody.data tr[indexRow='${typeAheadPointer}']`
      );
      let th = this.$el.querySelector('.ms-thead th');
      if (scroller && tr && th) {
        if (!scrollUp) {
          if (
            tr.getBoundingClientRect().top - th.getBoundingClientRect().top >=
            scroller.offsetHeight - th.offsetHeight
          ) {
            scroller.scrollTop += tr.offsetTop - trOld.offsetTop;
          }
        } else {
          if (tr.offsetTop <= th.offsetTop + tdHeight / 2) {
            scroller.scrollTop -= trOld.offsetTop - tr.offsetTop;
          }
        }
      }
    },

    // /**
    //  * Hàm thực hiện xử lý binding dữ liệu cho các grid có checkbox cho phép chọn row (v-model)
    //  * @param {[Object/String]} listItems Danh sách các item đang nằm trên grid hoặc danh sách ID của các Item cần check
    //  * @param {String} idField Primary key của model/object trong store
    //  */
    // setModelById(listItems, idField = null) {
    //   const me = this;
    //   listItems = listItems || [];
    //   //Trong trường hợp không phải grid allow check thì không cần làm gì
    //   if (!me.multiple) {
    //     return;
    //   }

    //   let keyField = null;
    //   if (idField) {
    //     keyField = idField;
    //   } else if (me.idField) {
    //     keyField = me.idField;
    //   }

    //   if (keyField) {
    //     let arrModel = [];

    //     listItems.forEach(id => {
    //       me.datax.forEach(item => {
    //         if (typeof id == "object") {
    //           if (item[keyField] == id[keyField]) {
    //             arrModel.push(item);
    //           }
    //         } else {
    //           if (item[keyField] == id) {
    //             arrModel.push(item);
    //           }
    //         }
    //       });
    //     });

    //     me.$emit("update:selected", arrModel);
    //   }
    // },

    /**
     * Thay đổi lock của column
     */
    columnChangeLock(col, locked) {
      const me = this;
      // let groups = me.columnx.filter(x => x.group === col.caption);
      // if (col.isGroup) {
      //   locked = !col.lock;
      //   col.lock = !col.lock;
      // }
      if (locked) {
        for (let i = 0; i < me.columnx.length; i++) {
          let column = me.columnx[i];
          column['lock'] = true;
          // if (col.isGroup) {
          //   if (groups[groups.length - 1]?.dataField === column.dataField) {
          //     break;
          //   }
          // } else {
          //   if (col === column) {
          //     break;
          //   }
          // }
          if (col === column) {
            break;
          }
        }
      } else {
        for (let i = me.columnx.length - 1; i >= 0; i--) {
          let column = me.columnx[i];
          column['lock'] = false;
          if (col === column) {
            break;
          }
        }
      }

      me.updateStickyOffset();
    },
    /**
     * Lấy style footer
     */
    getFooterStyle(col) {
      let res = {};
      if (typeof col.stickyOffset === 'number') {
        res.left = col.stickyOffset + 'px';
      }

      if (typeof col.width === 'number') {
        res.minWidth = res.width = col.width + 'px';
      }

      return res;
    },
    /**
     * scroll table
     * HTHIEP 28.03.2022: Sửa lỗi không có footer thì bỏ qua
     */
    tableScroll(e) {
      const target = e.target;
      if (
        target.scrollTop >= target.scrollHeight - target.offsetHeight &&
        this.data.length < this.pageTotal
      ) {
        this.$emit('onScrollBottom');
      }

      // Kiểm tra nếu có footer thì mới xử lý
      if (!this.footer) {
        return;
      }
      const me = this,
        tableFooter = me.$refs.tableFooter;

      tableFooter.scrollLeft = e.target.scrollLeft;
    },
    /**
     * Lấy dữ liệu data grid
     */
    getData() {
      return this.datax;
    },
    /**
     * Cập nhật lại dòng dữ liệu được focus
     * tbngoc 11.07.2022
     */
    updateSelectedRow(data, key) {
      let me = this;
      let dataGrid = me.getData();
      let newData = dataGrid.find((item) => item[key] == data[key]);
      let index = dataGrid.findIndex((item) => item[key] == data[key]);
      me.rowSelected.data = newData;
      me.rowSelected.index = index;
    },
  },
};
</script>
<style lang="scss" >
@import '@/assets/scss/components/MsGridViewer.scss';

.grid-scroll {
  .color-green {
    color: var(--primary) !important;
    font-weight: 600;
  }
}
input[type='checkbox'] {
  width: 16px !important;
  height: 16px !important;
  border-color: #707070 !important;
}
.ms-td,
.ms-th-content {
  min-height: 40px !important;
}
.table-footer {
  &.visibility {
    visibility: hidden;
    height: 0;
  }
  .footer-total-count {
    font-weight: 400;
    white-space: nowrap;
  }
  .footer-total-summary {
  }
}
.ms-thead {
  font-size: 14px;
}
.ms-th-title {
  width: 100%;
  justify-content: space-between;
}
.summary {
  font-weight: 600;
  position: sticky;
  top: 42px;
  z-index: 1;
  background-color: var(--white);
  border-bottom: 1px solid var(--secondary);
}
.summary-title {
  border-right: none;
}
</style>
